import { render, staticRenderFns } from "./OrderPriceIncorrectModal.vue?vue&type=template&id=4428c9aa"
import script from "./OrderPriceIncorrectModal.vue?vue&type=script&lang=js"
export * from "./OrderPriceIncorrectModal.vue?vue&type=script&lang=js"
import style0 from "./OrderPriceIncorrectModal.vue?vue&type=style&index=0&id=4428c9aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports